<template>
    <div class="position-box"> 
        <div class="head">        
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>    
            <div class="title">{{this.$t('zc.title')}}</div>                                
        </div> 
        <div class="cont-box">
            <div class="zc-box">
                <div class="zc-head">
                    <div class="text">{{this.$t('zc.zzczh')}}</div>                    
                    <img class="icon" src="@/assets/icon_show.png" v-show="isShow" @click="change" alt="">
                    <img class="icon" src="@/assets/icon_hide.png" v-show="!isShow" @click="change" alt="">
                </div>
                <div class="price"><div v-if="!isShow">******</div><div v-else>{{all_money}}</div> <span class="small">USDT</span></div>
            </div>
            <!-- <ul class="item-box">
                <router-link class="item" to="/chongbi" tag="li">
                    <div><img class="icon" src="@/assets/assets_Recharge.png" alt=""></div>
                    <div class="text">{{this.$t('zc.cb')}}</div>
                </router-link>
                <router-link class="item" to="/tibi" tag="li">
                    <div><img class="icon" src="@/assets/assets_Withdrawal.png" alt=""></div>
                    <div class="text">{{this.$t('zc.tb')}}</div>
                </router-link>
                <router-link class="item" to="/kjmbSelect" tag="li">
                    <div><img class="icon" src="@/assets/assets_Fast.png" alt=""></div>
                    <div class="text">{{this.$t('zc.kjmb')}}</div>
                </router-link>
                <router-link class="item" to="/duihuang" tag="li">
                    <div><img class="icon" src="@/assets/assets_exchange.png" alt=""></div>
                    <div class="text">{{this.$t('zc.dh')}}</div>
                </router-link>
                <li class="item" @click="sign">
                    <div><img class="icon" src="@/assets/btn-sign.png" alt=""></div>
                    <div class="text">{{this.$t('sign.title3')}}</div>
                </li>
                <router-link class="item" to="/cbsx" tag="li">
                    <div><img class="icon" src="@/assets/assets_Withdrawal2.png" alt=""></div>
                    <div class="text">{{this.$t('cbsx.title')}}</div>
                </router-link>
                <router-link class="item" to="/scList" tag="li">
                    <div><img class="icon" src="@/assets/Shopping Mall.png" alt=""></div>
                    <div class="text">{{this.$t('sc.title')}}</div>
                </router-link>
                <li class="item" @click="hotel">
                    <div><img class="icon" src="@/assets/hotel.png" alt=""></div>
                    <div class="text">{{this.$t('hotel.title')}}</div>
                </li>
            </ul> -->
            <!-- <div class="notice-box">
                <img class="icon" src="@/assets/assets_Notice.png" alt="">
                <div class="cont ellipse">
                    <swiper class="swiper notice-scroll" ref="mySwiper" :options="swiperOption">
                        <swiper-slide class="ellipse" v-for="(item,index) in newsArr" :key="index" :data-index="index">{{item.title | testSplit}}</swiper-slide>                                        
                    </swiper>
                </div>
                <img class="arrow" src="@/assets/arrow-white.png" alt="">
            </div> -->
            <div class="check-wrap">
                <div class="check-box"><input id="all" type="checkbox" v-model="check"></div>
                <div class="text"><label for="all">{{this.$t('zc.yczc')}}</label></div>
            </div>
            <ul class="ul-box">                   
                    <li class="list" v-if="check && btc_money != 0" @click="jump(4,'BTC',btc_money,(btc_money * btc).toFixed(4))">
                        <img class="img" src="@/assets/BTC.png" alt="">
                        <div class="title">BTC</div>
                        <div class="info-box">                                
                            <div class="price-box">
                                <div class="text1">{{this.$t('zc.xj')}}</div>
                                <div class="text2">{{btc_money}} BTC</div>
                            </div>
                            <div class="sl-box">
                                <div class="text1">{{btc}}</div>
                                <div class="text2">{{this.$t('zc.zh')}}{{btc_money * btc | toFixed}} USDT</div>
                            </div>
                        </div>                       
                    </li>     
                    <li class="list" v-else-if="!check" @click="jump(4,'BTC',btc_money,(btc_money * btc).toFixed(4))">
                        <img class="img" src="@/assets/BTC.png" alt="">
                        <div class="title">BTC</div>
                        <div class="info-box">                                
                            <div class="price-box">
                                <div class="text1">{{this.$t('zc.xj')}}</div>
                                <div class="text2">{{btc_money}} BTC</div>
                            </div>
                            <div class="sl-box">
                                <div class="text1">{{btc}}</div>
                                <div class="text2">{{this.$t('zc.zh')}}{{btc_money * btc | toFixed}} USDT</div>
                            </div>
                        </div>                       
                    </li>                    
                    <li class="list" v-if="check && btcm_money != 0" @click="jump(1,'GDCC',btcm_money,(btcm_money * 1.5).toFixed(4))">
                        <img class="img" src="@/assets/gdcc.png" alt="">
                        <div class="title">GDCC</div>
                        <div class="info-box">                                
                            <div class="price-box">
                                <div class="text1">{{this.$t('zc.xj')}}</div>
                                <div class="text2">{{btcm_money}} GDCC</div>
                            </div>
                            <div class="sl-box">
                                <div class="text1">1.5</div>
                                <div class="text2">{{this.$t('zc.zh')}}{{btcm_money*1.5 | toFixed}} USDT</div>
                            </div>
                        </div>                       
                    </li> 
                    <li class="list" v-else-if="!check" @click="jump(1,'GDCC',btcm_money,(btcm_money * 1.5).toFixed(4))">
                        <img class="img" src="@/assets/gdcc.png" alt="">
                        <div class="title gdcc">GDCC</div>
                        <div class="info-box">                                
                            <div class="price-box">
                                <div class="text1">{{this.$t('zc.xj')}}</div>
                                <div class="text2">{{btcm_money}} GDCC</div>
                            </div>
                            <div class="sl-box">
                                <div class="text1">1.5</div>
                                <div class="text2">{{this.$t('zc.zh')}}{{btcm_money*1.5 | toFixed}} USDT</div>
                            </div>
                        </div>                       
                    </li> 
                    <li class="list" v-if="check && eth_money != 0" @click="jump(3,'ETH',eth_money,(eth_money * eth).toFixed(4))">
                        <img class="img" src="@/assets/ETH.png" alt="">
                        <div class="title title2">ETH</div>
                        <div class="info-box">                                
                            <div class="price-box">
                                <div class="text1">{{this.$t('zc.xj')}}</div>
                                <div class="text2">{{eth_money}} ETH</div>
                            </div>
                            <div class="sl-box">
                                <div class="text1">{{eth}}</div>
                                <div class="text2">{{this.$t('zc.zh')}}{{eth_money*eth | toFixed}} USDT</div>
                            </div>
                        </div>                       
                    </li> 
                    <li class="list" v-else-if="!check" @click="jump(3,'ETH',eth_money,(eth_money * eth).toFixed(4))">
                        <img class="img" src="@/assets/ETH.png" alt="">
                        <div class="title title2">ETH</div>
                        <div class="info-box">                                
                            <div class="price-box">
                                <div class="text1">{{this.$t('zc.xj')}}</div>
                                <div class="text2">{{eth_money}} ETH</div>
                            </div>
                            <div class="sl-box">
                                <div class="text1">{{eth}}</div>
                                <div class="text2">{{this.$t('zc.zh')}}{{eth_money*eth | toFixed}} USDT</div>
                            </div>
                        </div>                       
                    </li> 
                    <li class="list" v-if="check && usdt_money != 0" @click="jump(2,'USDT',usdt_money,(usdt_money * 1).toFixed(4))">
                        <img class="img" src="@/assets/USDT.png" alt="">
                        <div class="title title2">USDT</div>
                        <div class="info-box">                                
                            <div class="price-box">
                                <div class="text1">{{this.$t('zc.xj')}}</div>
                                <div class="text2">{{usdt_money}} USDT</div>
                            </div>
                            <div class="sl-box">
                                <div class="text1">1</div>
                                <div class="text2">{{this.$t('zc.zh')}}{{usdt_money*1 | toFixed}} USDT</div>
                            </div>
                        </div>                       
                    </li>
                    <li class="list" v-else-if="!check" @click="jump(2,'USDT',usdt_money,(usdt_money * 1).toFixed(4))">
                        <img class="img" src="@/assets/USDT.png" alt="">
                        <div class="title title2">USDT</div>
                        <div class="info-box">                                
                            <div class="price-box">
                                <div class="text1">{{this.$t('zc.xj')}}</div>
                                <div class="text2">{{usdt_money}} USDT</div>
                            </div>
                            <div class="sl-box">
                                <div class="text1">1</div>
                                <div class="text2">{{this.$t('zc.zh')}}{{usdt_money*1 | toFixed}} USDT</div>
                            </div>
                        </div>                       
                    </li>
                </ul>           
            <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">            
        </div> 
        <div class="mask" v-show="isShowSmrz"></div>
        <!-- 实名认证 -->
        <div class="alert-wrap2" v-show="isShowSmrz">
            <div class="alert-head">
                {{this.$t('pay.wxts')}}
                <img class="icon" src="@/assets/close.png" @click="smrzClose" alt="">
            </div>
            <div class="tips">{{this.$t('smrz.tip6')}}</div>                
            <div class="btn-box">
                <button class="btn reset" type="button" @click="smrzClose">{{this.$t('duihuang.qx')}}</button>
                <button class="btn sure" type="button" @click="smrzSure">{{this.$t('smrz.qrz')}}</button>
            </div>
        </div>
        <!-- <nav-bar navName='zc'></nav-bar>         -->
    </div>
    
</template>

<script>
import navBar from '@/components/NavBar.vue'
import noData from '@/components/noData.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueBetterScroll from 'vue2-better-scroll'
let vm = null;
export default {
    name: 'zc',
    data () {
        return {
            listData: [],
            hasData: false,  
            isTop: false, 
            isShow: false,
            isShowSmrz: false,
            isSmrz: false,
            check: false,
            uid: '',
            token: '',
            btc: '',
            eth: '',
            all_money: '',
            btc_money: '',
            btcm_money: '',
            usdt_money: '',
            eth_money: '',
            newsArr: [],
            swiperOption: {
                notNextTick: true,
                loop: true,
                direction: "vertical", 
                autoplay:{
    　　　　　　　　delay: 2000,    　　　　　　　　
　　　　　　     },
                on:{
                    click: ()=>{   
                        let swiper = this.$refs.mySwiper.$swiper; 
                        let i = JSON.parse(swiper.clickedSlide.attributes['data-index'].nodeValue);                        
                        vm.getAlert(i);                                                
                    }
                },              
            },      
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')              
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')                    
                }
            },
            startY: 0, // 纵轴方向初始化位置            
            scrollToY: 0,
            scrollToTime: 500,
            page: 1,
            timer: null
        }            
    }, 
    created(){      
        vm = this;      
        let zcShow = localStorage.getItem('zcShow');        
        if(zcShow == null || zcShow == 'true'){
            localStorage.setItem('zcShow',true);
            this.isShow = true
        }else{
            localStorage.setItem('zcShow',false);
            this.isShow = false
        }   
    },
    mounted() {   
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token =localStorage.getItem('token'); 
        this.getMemberInfo();
        this.getNews();
        this.getNewestcurrency();
        this.getSmrz();
        this.timer = setInterval(()=>{
            this.getMemberInfo();
            this.getNewestcurrency()
        },3000);
        
    },     
    methods: {        
        getMemberInfo(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/member/getMemberInfo',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                    this.all_money = resData.all_money; 
                    this.btc_money = resData.btc_money;   
                    this.btcm_money = resData.btcm_money; 
                    this.eth_money = resData.eth_money;   
                    this.usdt_money = resData.usdt_money;              
                }else{
                    this.$router.push('/login')
                    // this.$toast.bottom(res.data.msg);                    
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },  
        getSmrz(){//实名认证状态
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/member/trueVerifiedStatus',params).then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){
                    if(resData == '' || resData == null){
                        this.isSmrz = true;                                                                  
                    }else{  
                         if(resData.is_verified == 0 || resData.is_verified == 2){
                             this.isSmrz = true;
                         }else{
                             this.isSmrz = false;
                         }
                    }                    
                }else{
                    this.$router.push('/login')                
                }
            }).catch(function(err){
                console.log(err)
            })
        },       
        getNews(){
            let params = {               
                page: 1,
                limit: 5
            }  
            this.$ajax.post('/api/index/announIndex',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                    if(resData.length > 0){
                        this.newsArr = resData;
                    }else{
                        this.newsArr = []
                    }                               
                }else{
                    // this.$toast.bottom(res.data.msg);                  
                }
            }).catch(function(err){
                console.log(err)
            })           
        }, 
        getNewestcurrency(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/miningmachine/newestcurrency',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                    this.btc = resData.btc;
                    this.eth = resData.eth;
                }else{
                    this.$router.push('/login')
                    // this.$toast.bottom(res.data.msg);                    
                }
            }).catch(function(err){
                console.log(err);                
            })     
        },
        init(curIdx,type){  
            let params = {
                type: type,
                page: 1
            }          
            this.$ajax.post('/api/newhand/index',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.ret == 200){
                     if(resData.length > 0){        
                        this.hasData = false
                        this.listData = resData;
                        this.$refs.scroll.forceUpdate(true)      
                    }else{
                        this.hasData = true;                       
                    }                       
                }else{
                    this.$router.push('/login')
                    // this.$toast.bottom(res.data.msg);                    
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },
         /* 下拉刷新的回调 */
        onPullingDown () {
            this.listData = []; 
            this.page = 1;
            this.init(this.curIdx,this.type)
        },
        onPullingUp(){            
            this.page ++;
            let params = {
                type: this.type,
                page: this.page
            } 
            this.$ajax.post('/api/newhand/index',params).then((res) => {                
                let resData = res.data.data;         
                if(res.data.ret == 200){                                          
                    if(resData.length > 0){
                        this.listData = this.listData.concat(resData);                        
                        this.$refs.scroll.forceUpdate(true) 
                    }else{
                         this.$refs.scroll.forceUpdate(false) 
                    }                
                }else{
                    this.$router.push('/login')
                    // this.$toast.bottom(res.data.msg);                  
                }
            }).catch(function(err){
                console.log(err); 
            })   
        }, 
        change(){
            this.isShow = !this.isShow;
            localStorage.setItem('zcShow',this.isShow)
        },
        getAlert(i){         
            // console.log(event)       
            let news = this.newsArr[i]; 
            localStorage.setItem('news',JSON.stringify(news))
			this.$router.push('/newsDetail');
        },
        scroll({x, y}){
            if(Math.abs(y) >= 300){
                this.isTop = true;
            }else{
                this.isTop = false
            }
        },    
        // 滚动到页面顶部
        scrollTo() {            
            this.$refs.scroll.scrollTo(this.scrollToY, this.scrollToTime)
        },
        sign(){
            if(this.isSmrz){
                this.isShowSmrz = true;
                return false;
            }else{
                this.isShowSmrz = false;
                this.$router.push('/sign')
            }
        },
        smrzSure(){
            this.$router.push('/smrz')
        },
        smrzClose(){
            this.isShowSmrz = false;
        },   
        jump(type,bz,ye,zhje){            
            this.$router.push('zcmx?type='+type+'&bz='+bz+'&ye='+ye+'&zhje='+zhje)
        },
        hotel(){
            this.$toast.bottom(this.$t('hotel.tips'));   
        },
        goBack(){
            this.$router.push('/user');
        },  
    },
    beforeDestroy(){       
        clearInterval(this.timer);        
        this.timer = null;      
    },
    filters: {        
        toFixed: function(val){           
            return val.toFixed(4)
        },
        testSplit: function(val){
            let len = 20;
            if (val.length >= len) {
                return val.substring(0, len) + "...";
            }else{
                return val;
            }
        }
    },
    components:{
        navBar,
        noData,
        Swiper,
        SwiperSlide,
        VueBetterScroll          
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;  
        color: #cecece;     
        font-size: .24rem;  
        background: url('../assets/element-background.png') no-repeat center center;  
        background-size: cover;
        overflow: hidden;       
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: .8rem;
        padding: 0 .24rem;
        color: #fff;
        font-size: .36rem;
        line-height: .8rem;   
        box-sizing: border-box;   
        /* background: #0e1530; */
        text-align: center;
    } 
    .head .icon{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .24rem;
        height: .44rem;
        transform: translateY(-50%);        
    } 
    .cont-box{
        position: absolute;
        left: 0;
        top: .8rem;
        bottom: 0;
        width: 100%;
        height: auto;  
        padding: 0 .24rem;  
        color: #cecece;   
        font-size: .24rem;
        box-sizing: border-box;   
        overflow: auto;       
    }  
    .zc-box{
        margin-top: .24rem;
        padding: .3rem .35rem .8rem .5rem;
        color: #fff;
        font-size: .24rem;
        border-left: .04rem solid #44CFFF;
        border-radius: 0 .1rem .1rem 0;
        background: rgba(26, 36, 63, .2);
    }
    .zc-box .zc-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .zc-box .zc-head .icon{
        width: .42rem;       
    }
    .zc-box .price{
        display: flex;
        align-items: center;
        padding-top: .46rem;
        color: #fff;
        font-size: .4rem;
    }
    .zc-box .price .input{
        width: auto;
        color: #fff;
        font-size: .48rem;
        background: transparent;
    }
    .zc-box .small{
        flex: 1;
        padding-left: .12rem;
        font-size: .3rem;
    }
    .item-box{
        display: flex;
        justify-content: flex-start;        
        flex-wrap: wrap;
        padding: .26rem 0 0;
        text-align: center;
    }    
    .item-box .item{
        width: 25%;
        margin-bottom: .4rem;
    }
    .item-box .icon{
        width: .6rem;
        /* height: .48rem; */
    }
    .item-box .text{
        padding-top: .18rem;
        color: #fff;
        font-size: .24rem;        
    }
    .notice-box{
        display: flex;
        align-items: center;  
        height: .8rem;    
        padding: 0 .44rem;  
        background: #040A26;
        border-radius: .4rem;
    }    
    .notice-box .icon{
        width: .38rem;
        height: .38rem;
    }
    .notice-box .cont{
        position: relative;
        flex: 1;
        height: .8rem;
        padding: 0 .32rem;
        color: #fff;
        line-height: .8rem;
        font-size: .28rem;
        overflow: hidden;
    }
    .notice-box .cont .notice-scroll{
        height: .8rem;
        overflow: hidden;
    }
    .notice-box .arrow{
        width: .14rem;
        height: .28rem;
    }
    .check-wrap{
        position: relative;
        z-index: 100;
        display: flex;
        align-items: center;
        padding: .2rem 0;
    }
    .check-wrap .text{
        padding-left: .14rem;
        color: #fff;
        font-size: .24rem;
    }     
    .list-bg{
        position: absolute;
        left: .24rem;
        right: .24rem;
        z-index: 999;
        width: auto;
        height: 4.5rem;        
        overflow: auto;
    }
    .ul-box .list{  
        position: relative;   
        display: flex;   
        align-items: center;   
        margin-bottom: .18rem;
        padding: .22rem .2rem .22rem .2rem;           
        background: rgb(4, 10, 38,.2);
        border-radius: .1rem;
    }    
    .ul-box .list .img{
        width: .62rem;
        height: .62rem;
    }
    .ul-box .list .title{
        width: 1rem;
        padding: 0 .28rem 0 .22rem;
        color: #EF9400;
        font-size: .34rem;
    }
    .ul-box .list .title2{
        color: #8c8c8c;
    }
    .ul-box .list .title.gdcc{
        color: #56c0e5;
    }
    .ul-box .list .info-box{
        flex: 1;        
        color: #fff;
        font-size: .28rem;
    }
    .ul-box .list .info-box .title{
        color: #fff;
        font-size: .28rem;
    }
    .ul-box .list .info-box .price-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .2rem;
    }
    .ul-box .list .info-box .sl-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .18rem;
    }    
    .ul-box .list .info-box .text2{
        flex: 1;
        text-align: right;
    }
    .list-foot{
        padding: .3rem .26rem 0;
        color: #cecece;
        font-size: .24rem;
    }
    .list-foot .item{
        margin-bottom: .12rem;
    }
    .list-foot .item:last-child{
        margin-bottom: 0;
    }
    .list-foot .item .red{
        color: #E12626;
    }
    .status{
        position: absolute;
        right: 0;
        top: 0;
        padding: .12rem .22rem;
        color: #fff;
        font-size: .24rem;        
        background: #2CAADE;
        border-radius: 0px 10px 0px 10px;
    }
    .status.active{        
        background: #9D9D9D;
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }    
    .alert-wrap2{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 50%;
        z-index: 1000;
        width: auto;        
        background: #1A2440;
        border-radius: .2rem; 
        transform: translateY(-50%);       
    }
    .alert-wrap2 .tips{
        padding: 0 .44rem .44rem;
        color: #D1D1D1;
        font-size: .24rem;
    }    
    .alert-wrap2 .btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-wrap2 .btn-box .btn{
        width: 50%;
        height: .9rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .btn-box .reset{
        background: #4F608E;
        border-radius: 0 0 0 .2rem;
    }
    .alert-wrap2 .btn-box .sure{
        background: #677DB9;
        border-radius: 0 0 .2rem 0;
    }
</style>


// WEBPACK FOOTER //
// src/pages/zc.vue